import React from 'react'

import { DlIcon } from 'components/Utils/Icons'
import ModalLink from 'components/Utils/Modal/Link'
import { IMPORT_FILES } from 'components/Utils/Modal/constants'
import { RowLayout } from './RowLayout'

export const ImportLink = () => (
  <RowLayout
    renderComponent={props => <ModalLink {...props} to={IMPORT_FILES} />}
    depth={0}
    icon={<DlIcon size={14} />}
    label="Import content"
  />
)
